import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { fitmentData } from "../data/fitmentData";

const API = "https://eleven11-i6v4.onrender.com";

const inp = {
  width: "100%", padding: "14px 16px", borderRadius: 14,
  border: "1.5px solid #E5E5EA", background: "#FAFAFA",
  fontSize: 15, color: "#0f0f17", outline: "none",
  boxSizing: "border-box", fontFamily: "-apple-system, BlinkMacSystemFont, system-ui",
  appearance: "none", WebkitAppearance: "none"
};

function Label({ children }) {
  return (
    <div style={{ fontSize: 12, fontWeight: 700, color: "#9ca3af", letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 8, marginTop: 18 }}>
      {children}
    </div>
  );
}

function Card({ title, children, accent }) {
  return (
    <div style={{ background: "#fff", borderRadius: 20, marginBottom: 14, overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
      {title && (
        <div style={{ padding: "16px 18px 12px", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 10 }}>
          {accent && <div style={{ width: 4, height: 20, borderRadius: 999, background: accent }} />}
          <div style={{ fontSize: 14, fontWeight: 800, color: "#0f0f17" }}>{title}</div>
        </div>
      )}
      <div style={{ padding: "14px 18px 18px" }}>{children}</div>
    </div>
  );
}

export default function CreateListingMobile() {
  const { listingId } = useParams();
  const navigate = useNavigate();
  const isEdit = !!listingId;

  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    title: "", partNumber: "", eid: "", badge: "", manufacturer: "",
    description: "", keywords: "", category: "", condition: "used",
    weightValue: "", weightUnit: "lbs", color: "", material: "",
    unitsAvailable: "", images: [], year: "", useYearRange: false,
    yearStart: "", yearEnd: "", model: "",
partType: "Factory OEM", conditionGrade: "", conditionNotes: "",
sku: "", costPrice: "", supplier: "", binLocation: "",
lowStockThreshold: "", altPartNumbers: "", compatibilityNotes: "",
isFeatured: false, isPublished: true
  });

const [variants, setVariants] = useState({
    new: { price: "", stock: "" },
    used: { price: "", stock: "" }
  });

  const [variantImages, setVariantImages] = useState({
    new: [],
    used: []
  });
 

  const selectedYear = form.useYearRange ? form.yearStart : (form.year || form.yearStart);
  const models = fitmentData[form.manufacturer]?.[selectedYear] || [];

  useEffect(() => {
    if (!listingId) return;
    fetch(`${API}/api/listings/${listingId}`)
      .then(r => r.json())
      .then(data => {
        setForm(prev => ({
          ...prev, ...data,
          useYearRange: data.yearStart && data.yearEnd && data.yearStart !== data.yearEnd,
          year: data.yearStart || "",
          yearStart: data.yearStart || "",
          yearEnd: data.yearEnd || "",
keywords: (data.keywords || []).join(", "),
        compatibleFitments: data.compatibleModels || data.compatibleFitments || [],
          images: (data.images || []).map(img => ({ preview: `${img}`, existing: true, path: img }))
        }));
     setCompatibleFitments(data.compatibleModels || []);
        if (data.variants) {
          const s = { new: { price: "", stock: "" }, used: { price: "", stock: "" } };
          data.variants.forEach(v => {
            if (v.condition === "new" || v.condition === "used")
              s[v.condition] = { price: v.price, stock: v.stock };
          });
          setVariants(s);


          setVariantImages({
            new: (data.variants?.find(v => v.condition === "new")?.images || []).map(img => ({ preview: img, existing: true, path: img })),
            used: (data.variants?.find(v => v.condition === "used")?.images || []).map(img => ({ preview: img, existing: true, path: img }))
          });
        }
      }).catch(console.error);



  }, [listingId]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => {
      const updated = { ...prev, [name]: value };
      if (name === "partNumber") updated.eid = value ? `E11-${value}` : "";
      const currentModel = prev.model;
      if ((name === "year" || name === "manufacturer" || name === "yearStart") && currentModel) {
        const validModels = fitmentData[name === "manufacturer" ? value : prev.manufacturer]?.[
          name === "year" || name === "yearStart" ? value : (prev.useYearRange ? prev.yearStart : prev.year)
        ] || [];
        if (!validModels.includes(currentModel)) updated.model = "";
      }
      return updated;
    });
  };

  const handleImageUpload = files => {
    const newImgs = Array.from(files).map(file => ({ file, preview: URL.createObjectURL(file) }));
    setForm(prev => ({ ...prev, images: [...prev.images, ...newImgs] }));
  };

  const removeImage = index => {
    const updated = [...form.images];
    if (updated[index].file) URL.revokeObjectURL(updated[index].preview);
    updated.splice(index, 1);
    setForm(prev => ({ ...prev, images: updated }));
  };

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const fd = new FormData();
      const yearStart = form.useYearRange ? form.yearStart : form.year;
      const yearEnd = form.useYearRange ? form.yearEnd : form.year;

["title","partNumber","eid","badge","partType","description","category","condition","weightValue","weightUnit","color","material","unitsAvailable","conditionGrade","conditionNotes","sku","costPrice","supplier","binLocation","lowStockThreshold","altPartNumbers","compatibilityNotes"]
  .forEach(k => fd.append(k, form[k] || ""));
fd.append("isFeatured", form.isFeatured ? "true" : "false");
fd.append("isPublished", form.isPublished ? "true" : "false");
      fd.append("yearStart", yearStart);
      fd.append("yearEnd", yearEnd);
      fd.append("model", form.model);
      fd.append("manufacturer", form.manufacturer);

      let compatibleModels = [];
      if (form.model) {
        for (let y = Number(yearStart); y <= Number(yearEnd); y++)
          compatibleModels.push(`${y} ${form.manufacturer} ${form.model}`);
      }
fd.append("compatibleModels", JSON.stringify(compatibleFitments));
      variantImages.new.forEach(img => { if (img.file) fd.append("newImages", img.file); });
      variantImages.used.forEach(img => { if (img.file) fd.append("usedImages", img.file); });
      fd.append("existingNewImages", JSON.stringify(variantImages.new.filter(i => i.existing).map(i => i.path)));
      fd.append("existingUsedImages", JSON.stringify(variantImages.used.filter(i => i.existing).map(i => i.path)));

      const formattedVariants = [];
      if (variants.new.price) formattedVariants.push({ condition: "new", label: "Brand New", price: Number(variants.new.price), stock: Number(variants.new.stock || 0) });
      if (variants.used.price) formattedVariants.push({ condition: "used", label: "Used (Like New)", price: Number(variants.used.price), stock: Number(variants.used.stock || 0) });
      fd.append("variants", JSON.stringify(formattedVariants));

      const keywordArray = form.keywords ? form.keywords.split(",").map(k => k.trim()).filter(Boolean) : [];
      fd.append("keywords", JSON.stringify(keywordArray));

const url = isEdit ? `${API}/api/listings/${listingId}` : `${API}/api/listings`;
      const token = localStorage.getItem("token");
      const res = await fetch(url, {
        method: isEdit ? "PUT" : "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: fd
      });


      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Request failed");
      alert(isEdit ? "Listing Updated ✓" : "Listing Created ✓");
      navigate("/admin");
    } catch (err) {
      alert(`Error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

const YEARS = [...Array(29)].map((_, i) => 2025 - i);

const CATEGORIES = ["Parts", "Accessories", "Marine Detailing", "Lubricants & Sprays", "Fluids & Maintenance"];

  const [fitmentPicker, setFitmentPicker] = useState({ manufacturer: "", year: "", model: "" });
  const fitmentPickerModels = fitmentData[fitmentPicker.manufacturer]?.[fitmentPicker.year] || [];
  const [compatibleFitments, setCompatibleFitments] = useState([]);


  const MANUFACTURERS = ["Yamaha", "Sea-Doo", "Kawasaki", "Kommander", "Crc Industries", "Liqui Moly", "CorrosionX", "Salty Captain", "Salt Away", "NGK"];

  return (
    <div style={{ background: "#F4F5F7", minHeight: "100vh", fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui", paddingBottom: 120 }}>

      {/* Header */}
      <div style={{ background: "#fff", padding: "16px 18px 14px", borderBottom: "1px solid #f3f4f6", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => navigate("/admin")} style={{ background: "#f3f4f6", border: "none", borderRadius: 10, padding: "8px 14px", fontSize: 14, fontWeight: 600, cursor: "pointer", color: "#374151" }}>←</button>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, color: "#9ca3af" }}>ELEVEN ADMIN</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#0f0f17", letterSpacing: -0.5 }}>{isEdit ? "Edit Listing" : "New Listing"}</div>
          </div>
        </div>
      </div>

      <div style={{ padding: "16px 16px 0" }}>

        {/* FITMENT */}
        <Card title="Fitment" accent="#6366f1">
          <Label>Manufacturer</Label>
          <select name="manufacturer" value={form.manufacturer} onChange={handleChange} style={inp}>
            <option value="">Select Manufacturer</option>
            {MANUFACTURERS.map(m => <option key={m} value={m}>{m}</option>)}
          </select>

          <Label>Year</Label>
          <select name="year" value={form.useYearRange ? "" : (form.year || form.yearStart)} onChange={handleChange} style={{ ...inp, color: form.useYearRange ? "#9ca3af" : "#0f0f17" }} disabled={form.useYearRange}>
            <option value="">Select Year</option>
            {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>

          <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 12, padding: "12px 14px", background: "#f9fafb", borderRadius: 12, border: "1px solid #e5e7eb" }}>
            <input
              type="checkbox" id="yearRange" checked={form.useYearRange}
              onChange={e => setForm(prev => ({ ...prev, useYearRange: e.target.checked, yearStart: prev.year || "", yearEnd: prev.year || "", model: "" }))}
              style={{ width: 18, height: 18, accentColor: "#6366f1", cursor: "pointer" }}
            />
            <label htmlFor="yearRange" style={{ fontSize: 14, fontWeight: 600, color: "#374151", cursor: "pointer" }}>Interchangeable Years</label>
          </div>

          {form.useYearRange && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 12 }}>
              <div>
                <Label>From</Label>
                <select name="yearStart" value={form.yearStart} onChange={handleChange} style={inp}>
                  <option value="">From</option>
                  {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
              <div>
                <Label>To</Label>
                <select name="yearEnd" value={form.yearEnd} onChange={handleChange} style={inp}>
                  <option value="">To</option>
                  {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
                </select>
              </div>
            </div>
          )}

          <Label>Model</Label>
          <select name="model" value={form.model} onChange={handleChange} style={{ ...inp, color: (!form.manufacturer || !selectedYear) ? "#9ca3af" : "#0f0f17" }} disabled={!form.manufacturer || !selectedYear}>
            <option value="">Select Model</option>
            {models.map(m => <option key={m} value={m}>{m}</option>)}
          </select>

        <Label>Compatible Models</Label>
          <div style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
            <select value={fitmentPicker.manufacturer} style={{ ...inp, flex: 1, minWidth: 110 }} onChange={e => setFitmentPicker(p => ({ ...p, manufacturer: e.target.value, year: "", model: "" }))}>
              <option value="">Make</option>
              <option value="Yamaha">Yamaha</option>
              <option value="Sea-Doo">Sea-Doo</option>
              <option value="Kawasaki">Kawasaki</option>
            </select>
            <select value={fitmentPicker.year} style={{ ...inp, flex: 1, minWidth: 80 }} onChange={e => setFitmentPicker(p => ({ ...p, year: e.target.value, model: "" }))} disabled={!fitmentPicker.manufacturer}>
              <option value="">Year</option>
              {YEARS.map(y => <option key={y} value={String(y)}>{y}</option>)}
            </select>
            <select value={fitmentPicker.model} style={{ ...inp, flex: 2, minWidth: 120 }} onChange={e => setFitmentPicker(p => ({ ...p, model: e.target.value }))} disabled={!fitmentPicker.year || fitmentPickerModels.length === 0}>
              <option value="">Model</option>
              {fitmentPickerModels.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <button type="button" onClick={() => {
            const { manufacturer, year, model } = fitmentPicker;
            if (!manufacturer || !year || !model) return;
            const entry = `${year} ${manufacturer} ${model}`;
            if (compatibleFitments.includes(entry)) return;
            setCompatibleFitments(p => [...p, entry]);
            setFitmentPicker(p => ({ ...p, model: "" }));
          }} style={{ width: "100%", padding: "12px", borderRadius: 12, border: "none", background: "#111", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", marginBottom: 10 }}>
            + Add Fitment
          </button>
          {compatibleFitments.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
              {compatibleFitments.map((entry, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, background: "#f0f0ff", border: "1px solid #c7c7ff", borderRadius: 999, padding: "5px 12px", fontSize: 12, fontWeight: 600, color: "#3730a3" }}>
                  {entry}
                  <button type="button" onClick={() => setCompatibleFitments(p => p.filter((_, idx) => idx !== i))} style={{ background: "none", border: "none", cursor: "pointer", color: "#9ca3af", fontSize: 14, lineHeight: 1, padding: 0 }}>×</button>
                </div>
              ))}
            </div>
          )}

          <Label>Category</Label>
          <select name="category" value={form.category} onChange={handleChange} style={inp}>
            <option value="">Select Category</option>
            {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>

          <Label>Condition</Label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {["used", "new"].map(c => (
              <button key={c} onClick={() => setForm(p => ({ ...p, condition: c }))} style={{ padding: "14px", borderRadius: 14, border: `2px solid ${form.condition === c ? "#0f0f17" : "#e5e7eb"}`, background: form.condition === c ? "#0f0f17" : "#fff", color: form.condition === c ? "#fff" : "#374151", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
                {c === "new" ? "Brand New" : "Used"}
              </button>
            ))}
          </div>
        </Card>

        {/* IDENTIFICATION */}
        <Card title="Identification" accent="#0ea5e9">
          <Label>Part Number</Label>
          <input name="partNumber" value={form.partNumber} onChange={handleChange} style={inp} placeholder="e.g. 6BH-13750-10-00" />

          <Label>Title</Label>
          <input name="title" value={form.title} onChange={handleChange} style={inp} placeholder="Yamaha 1.8L Throttle Body ASSY" />

          <Label>EID (Auto-generated)</Label>
          <input name="eid" value={form.eid} onChange={handleChange} style={{ ...inp, color: "#9ca3af" }} placeholder="E11-..." />

        <Label>Social Proof Badge</Label>
          <input name="badge" value={form.badge} onChange={handleChange} style={inp} placeholder="e.g. Top Seller · 5K+ Ordered" />

          <Label>Part Type</Label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {["Factory OEM", "Reman OEM", "OEM Takeoff", "Aftermarket"].map(t => (
              <button key={t} onClick={() => setForm(p => ({ ...p, partType: t }))} style={{ padding: "11px 10px", borderRadius: 14, border: `2px solid ${form.partType === t ? "#0f0f17" : "#e5e7eb"}`, background: form.partType === t ? "#0f0f17" : "#fff", color: form.partType === t ? "#fff" : "#374151", fontSize: 12, fontWeight: 700, cursor: "pointer", textAlign: "center" }}>
                {t}
              </button>
            ))}
          </div>
        </Card>
        

        {/* DESCRIPTION */}
        <Card title="Description & Keywords" accent="#f59e0b">
          <Label>Description</Label>
          <textarea
            name="description" value={form.description} onChange={handleChange} rows={5}
            style={{ ...inp, resize: "vertical", lineHeight: 1.6 }}
            placeholder="Describe the part condition, compatibility, and any important notes..."
          />

          <Label>Search Keywords</Label>
          <input name="keywords" value={form.keywords} onChange={handleChange} style={inp} placeholder="fuel pump, yamaha oem, marine fuel system" />
        </Card>


        {/* CONDITION RATING */}
<Card title="Condition Rating" accent="#f43f5e">
  <Label>Grade</Label>
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
    {[
      { key: "excellent", label: "Excellent", sub: "Like new, no wear" },
      { key: "good", label: "Good", sub: "Minor signs of use" },
      { key: "fair", label: "Fair", sub: "Visible wear, fully functional" },
      { key: "poor", label: "Poor", sub: "Heavy wear, still works" },
    ].map(g => (
      <button key={g.key} onClick={() => setForm(p => ({ ...p, conditionGrade: g.key }))} style={{ padding: "12px 10px", borderRadius: 14, border: `2px solid ${form.conditionGrade === g.key ? "#f43f5e" : "#e5e7eb"}`, background: form.conditionGrade === g.key ? "#fff1f2" : "#fff", cursor: "pointer", textAlign: "left" }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: form.conditionGrade === g.key ? "#f43f5e" : "#0f0f17" }}>{g.label}</div>
        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 2 }}>{g.sub}</div>
      </button>
    ))}
  </div>
  <Label>Condition Notes <span style={{ fontWeight: 400, color: "#9ca3af" }}>(optional)</span></Label>
  <textarea name="conditionNotes" value={form.conditionNotes || ""} onChange={handleChange} rows={3} style={{ ...inp, resize: "vertical", lineHeight: 1.6, padding: "14px 16px" }} placeholder="e.g. Small scratch on housing, otherwise perfect. All connectors intact." />
</Card>

{/* INTERNAL / OPERATIONS */}
<Card title="Internal & Operations" accent="#6366f1">
  <Label>SKU / Internal Reference</Label>
  <input name="sku" value={form.sku || ""} onChange={handleChange} style={inp} placeholder="e.g. YAM-ECU-001" />

  <Label>Cost Price <span style={{ fontWeight: 400, color: "#9ca3af", textTransform: "none" }}>(private)</span></Label>
  <input type="number" name="costPrice" value={form.costPrice || ""} onChange={handleChange} style={inp} placeholder="0.00" />

  <Label>Supplier / Source</Label>
  <input name="supplier" value={form.supplier || ""} onChange={handleChange} style={inp} placeholder="e.g. Dealer Auction, Wholesale, Direct Pull" />

  <Label>Bin / Shelf Location</Label>
  <input name="binLocation" value={form.binLocation || ""} onChange={handleChange} style={inp} placeholder="e.g. A3-B2, Shelf 4" />

  <Label>Low Stock Alert Threshold</Label>
  <input type="number" name="lowStockThreshold" value={form.lowStockThreshold || ""} onChange={handleChange} style={inp} placeholder="3" />

  <Label>Alternate Part Numbers <span style={{ fontWeight: 400, color: "#9ca3af", textTransform: "none" }}>(optional)</span></Label>
  <input name="altPartNumbers" value={form.altPartNumbers || ""} onChange={handleChange} style={inp} placeholder="e.g. 6BH-13750-00-00, 6BH-13750-09-00" />

  <Label>Compatibility Notes <span style={{ fontWeight: 400, color: "#9ca3af", textTransform: "none" }}>(optional)</span></Label>
  <textarea name="compatibilityNotes" value={form.compatibilityNotes || ""} onChange={handleChange} rows={3} style={{ ...inp, resize: "vertical", lineHeight: 1.6, padding: "14px 16px" }} placeholder="e.g. Fits 2019 FX SVHO but requires bracket E11-XXXXX" />

  <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
    <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14, cursor: "pointer", padding: "12px 14px", background: "#f9fafb", borderRadius: 12, border: "1px solid #e5e7eb" }}>
      <input type="checkbox" checked={form.isFeatured} onChange={e => setForm(p => ({ ...p, isFeatured: e.target.checked }))} style={{ width: 18, height: 18, accentColor: "#6366f1" }} />
      <div>
        <div style={{ fontWeight: 700, color: "#0f0f17" }}>Featured listing</div>
        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>Pinned to top of rails and category pages</div>
      </div>
    </label>
    <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14, cursor: "pointer", padding: "12px 14px", background: "#f9fafb", borderRadius: 12, border: "1px solid #e5e7eb" }}>
      <input type="checkbox" checked={form.isPublished} onChange={e => setForm(p => ({ ...p, isPublished: e.target.checked }))} style={{ width: 18, height: 18, accentColor: "#10b981" }} />
      <div>
        <div style={{ fontWeight: 700, color: "#0f0f17" }}>Published</div>
        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>Visible to customers on the platform</div>
      </div>
    </label>
  </div>
</Card>

     {/* PRICING */}
        <Card title="Condition & Pricing" accent="#10b981">
          {[
            { key: "new",  label: "Brand New (OEM)",  color: "#0ea5e9", bg: "#e0f2fe" },
            { key: "used", label: "Used (Like New)",   color: "#6b7280", bg: "#f3f4f6" }
          ].map(v => (
            <div key={v.key} style={{ marginBottom: 14, padding: "16px", background: "#f9fafb", borderRadius: 16, border: "1.5px solid #e5e7eb" }}>
              <span style={{ background: v.bg, color: v.color, fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 999 }}>{v.label}</span>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 14 }}>
                <div>
                  <Label>Price ($)</Label>
                  <input type="number" placeholder="0.00" value={variants[v.key].price} onChange={e => setVariants(p => ({ ...p, [v.key]: { ...p[v.key], price: e.target.value } }))} style={inp} />
                </div>
                <div>
                  <Label>Stock</Label>
                  <input type="number" placeholder="0" value={variants[v.key].stock} onChange={e => setVariants(p => ({ ...p, [v.key]: { ...p[v.key], stock: e.target.value } }))} style={inp} />
                </div>
              </div>
              <Label>Photos — {v.label}</Label>
              <label style={{ display: "block", padding: "14px", border: "2px dashed #d1d5db", borderRadius: 12, textAlign: "center", cursor: "pointer", background: "#fff", marginBottom: 10 }}>
                <input type="file" accept="image/*" multiple onChange={e => {
                  const imgs = Array.from(e.target.files).map(file => ({ file, preview: URL.createObjectURL(file) }));
                  setVariantImages(p => ({ ...p, [v.key]: [...p[v.key], ...imgs] }));
                }} style={{ display: "none" }} />
                <div style={{ fontSize: 20, marginBottom: 4 }}>📷</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Tap to upload</div>
              </label>
              {variantImages[v.key].length > 0 && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                  {variantImages[v.key].map((img, i) => (
                    <div key={i} style={{ position: "relative", aspectRatio: "1", borderRadius: 12, overflow: "hidden", background: "#f3f4f6" }}>
                      <img src={img.preview} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      <button onClick={() => {
                        if (variantImages[v.key][i].file) URL.revokeObjectURL(variantImages[v.key][i].preview);
                        setVariantImages(p => ({ ...p, [v.key]: p[v.key].filter((_, idx) => idx !== i) }));
                      }} style={{ position: "absolute", top: 4, right: 4, width: 22, height: 22, borderRadius: "50%", background: "rgba(0,0,0,0.6)", border: "none", color: "#fff", fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>×</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          <Label>Total Units Available</Label>
          <input type="number" name="unitsAvailable" value={form.unitsAvailable} onChange={handleChange} style={inp} placeholder="0" />
        </Card>

        

        {/* SPECS */}
        <Card title="Specifications" accent="#f97316">
          <Label>Weight</Label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 10 }}>
            <input name="weightValue" value={form.weightValue} onChange={handleChange} style={inp} placeholder="0" />
            <select name="weightUnit" value={form.weightUnit} onChange={handleChange} style={{ ...inp, width: 100 }}>
              <option value="lbs">lbs</option>
              <option value="oz">oz</option>
              <option value="g">grams</option>
              <option value="kg">kg</option>
            </select>
          </div>

          <Label>Color</Label>
          <input name="color" value={form.color} onChange={handleChange} style={inp} placeholder="e.g. Black" />

          <Label>Material</Label>
          <input name="material" value={form.material} onChange={handleChange} style={inp} placeholder="e.g. Aluminum, Plastic" />
        </Card>

      </div>

      {/* Sticky Bottom CTA */}
      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, padding: "16px 16px calc(16px + env(safe-area-inset-bottom))", background: "rgba(255,255,255,0.95)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)", borderTop: "1px solid rgba(0,0,0,0.08)", zIndex: 100 }}>
        <button
          onClick={handleSubmit} disabled={saving}
          style={{ width: "100%", padding: "16px", borderRadius: 16, border: "none", background: saving ? "#9ca3af" : "#0f0f17", color: "#fff", fontSize: 16, fontWeight: 800, cursor: saving ? "not-allowed" : "pointer", letterSpacing: -0.3, transition: "all 0.2s" }}
        >
          {saving ? "Saving..." : isEdit ? "Save Changes" : "Create Listing"}
        </button>
      </div>
    </div>
  );
}